import { BrandMark } from "./Header";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#why-dumpd", label: "Why Us" },
  { href: "#service-area", label: "Service Area" },
  { href: "#gallery", label: "Recent Hauls" },
  { href: "#pricing-guide", label: "Process" },
  { href: "#pricing", label: "Pricing" },
  { href: "#reviews", label: "Reviews" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black border-t border-zinc-900 py-16 px-4 sm:px-6 lg:px-8 text-zinc-400 text-xs font-mono">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8 border-b border-zinc-900 pb-12">
        <div>
          <div className="flex items-center gap-2">
            <BrandMark size="w-6 h-6" />
            <span className="font-display text-white text-lg font-black tracking-tight uppercase">DUMP'D Junk Removal</span>
          </div>
          <p className="mt-2 text-zinc-400">Clear Space. Better Days.</p>
          <p className="text-zinc-400 mt-1">Palm Bay, FL • Serving Brevard County</p>
        </div>

        <div className="flex flex-wrap gap-6 text-zinc-400 uppercase tracking-wider">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-white transition-colors">
              {l.label}
            </a>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-zinc-400">
        <div>DUMP'D Junk Removal Services • Brevard County, Florida</div>
        <div className="flex gap-4">
          <span>dumpdjunk.com</span>
          <span>•</span>
          <a href="tel:3214202707" data-testid="footer-call-link" className="hover:text-white transition-colors">(321) 420-2707</a>
        </div>
      </div>
    </footer>
  );
}
